/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/dialogs/sendmessage/app.dialogs.sendmessage.component.ts.
 */
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '../../models/user';
import {Subscription} from 'rxjs';
import {AppUserService} from '../../services/app.user.service';


/**
 * Zweck: Beschreibt class AppDialogsSendmessageComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.dialogs.sendmessage.component.html',
    styleUrls: ['app.dialogs.sendmessage.component.scss'],
    standalone: false
})
export class AppDialogsSendmessageComponent implements OnInit, OnDestroy {
  icon = 'nachricht';
  label: string;
  text: string;
  url: string;
  is_popup = true;
  dismissable = true;

  current_user: User;

  ulistener: Subscription;
  send_ready = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<AppDialogsSendmessageComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private usvc: AppUserService) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.ulistener instanceof Subscription) {
      this.ulistener.unsubscribe();
    }
  }

/**
 * Beschreibt Methode changeData und ihren Rückgabevertrag.
 */
  changeData() {
    if (this.label !== '' && this.icon !== '' && this.text !== '') {
      this.send_ready = true;
    } else {
      this.send_ready = false;
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.ulistener = this.usvc.user$.subscribe(u => this.current_user = u);
  }

/**
 * Beschreibt Methode send und ihren Rückgabevertrag.
 */
  send() {
    this.dialogRef.close({
      label: this.label,
      icon: this.icon,
      text: this.text,
      url: this.url,
      is_popup: this.is_popup,
      dismissable: this.dismissable
    });
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel() {
    this.dialogRef.close(false);
  }
}
